import { APIAppInstanceState } from "../../Reducers/API/AppInstance/AppInstanceReducer"

export enum AppStatusPrivateLabeling {
    uploadSuggested = "uploadSuggested",
    inviteSuggested = "inviteSuggested"
}

export function getAppStatusPrivateLabeling(
    instance: APIAppInstanceState
): AppStatusPrivateLabeling | undefined {
    if (
        instance.job_stats === null ||
        !("collaborator_jobs" in instance.job_stats)
    ) {
        return undefined
    }

    const { collaborator_jobs, completed_collaborator_jobs } =
        instance.job_stats

    if (collaborator_jobs === 0 && instance.batchProcessCount === 0) {
        return AppStatusPrivateLabeling.uploadSuggested
    }

    if (completed_collaborator_jobs === 0) {
        return AppStatusPrivateLabeling.inviteSuggested
    }

    return undefined
}
